import React from 'react'

function Footer() {
    return (
        <div>
            <footer className="mt-5 pt-5 text-muted text-center text-small ">
                
                    <a className='text-light' href="https://www.linkedin.com/in/imrancaglaeyuboglu/"><i className="fab fa-linkedin fa-2x px-2"></i></a>
                    <a className='text-light' href="https://github.com/imcagla"><i className="fab fa-github-square fa-2x px-2"></i></a>
                
                <p className="mb-0 py-4 mt-auto">&copy; 2021 Imran Cagla Eyuboglu - UP SCHOOL</p>
            </footer>
        </div>
        
    )
}

export default Footer
